const { uuid } = require('uuidv4')
import airplane3D from '..//data/airplane.glb'
import airplane2D from '..//data/airplane2D.png'
const {KalmanFilter} = require('kalman-filter')
const kFilter = new KalmanFilter({observation: 3})
import { mapper } from '../data/flightMapper'
import { checkMobile } from '../js/utils'
export function createDescription(data){
  return  { 
      id :uuid(),
      placeholder : getPlaceHolder(data),
      callSign : data[16],
      depArr : data[11] + "-" + data[12],
      heading : data[3]-90,
      dep : data[11],
      arr : data[12],
      pos : {lng :data[2], lat : data[1], height : data[4]/3280.8*1000},
      lastUpdate : new Date().getTime()
  }
}

export function createDescriptionForAdsb(data){
  let _dep = ""
  let _arr = ""
  if(data.DEP_ARR_DIV_CD==='D'){
    _dep = data.IATA_APCD
    _arr = data.PTN_IATA_APCD
  } else { 
    _dep = data.PTN_IATA_APCD
    _arr = data.IATA_APCD
  }
  return  { 
      id :uuid(),
      placeholder : getPlaceHolderForAdsb(data),
      callSign : data.FLY_FL_NM,
      heading : data.DIR-90,
      dep : _dep,
      arr : _arr,
      pos : {lng : Number.parseFloat(data.YXS).toFixed(6), lat : Number.parseFloat(data.XXS).toFixed(6), height : Number.parseFloat(data.ALTD)*0.3048},
      lastUpdate : new Date().getTime()
  }
}

export function getPlaceHolder(data){
  let placeHolder = ""
  placeHolder = placeHolder + convertIcaoToIata(data[16])
  if(data[11]  !==''){
    placeHolder =  placeHolder + '\n' + data[11] + "-" + data[12]
  }
  placeHolder = placeHolder + '\n' + parseInt(data[4]/3280.8*1000).toFixed(0)  +'m'
  return placeHolder 
}

export function convertIcaoToIata(val){
  let newVal = ''
  for(let i in mapper){
    if(val.includes(mapper[i].bar__2)){
      newVal = val.replace(mapper[i].bar__2,mapper[i].IATA)
      return newVal
    }
  }

  return val 
}

export function getPlaceHolderForAdsb(data){
  let placeHolder = ""
  placeHolder = placeHolder + data.FLY_FL_NM
  if(data.DEP_ARR_DIV_CD==='D'){
    placeHolder =  placeHolder + '\n' + data.IATA_APCD + "-" +  data.PTN_IATA_APCD
  } else {
    placeHolder =  placeHolder + '\n' + data.PTN_IATA_APCD + "-" +  data.IATA_APCD
  }
  placeHolder = placeHolder + '\n' + (Number.parseFloat(data.ALTD)*0.3048).toFixed(0)  +'m'  
  return placeHolder 
}

export function createEntity(stat,position,orientation,dataInstance){
  
  let isVisible = true 
  if(stat.isEnrouteTrackVisible){
    isVisible = true
  } else{
    isVisible = false
  }

  if(checkMobile()==="ios"||checkMobile()==="android"){
    return  {
      id: dataInstance.id,
      name : 'track',
      position: position,
      show: isVisible,
      billboard: {
        image: airplane2D,
        scaleByDistance: new Cesium.NearFarScalar(1.5e2, 0.1, 1.5e7, 0.15),
      },
      label: {
          text: dataInstance.placeholder,
          font: "10px sans-serif",
          showBackground: true,
          pixelOffset: new Cesium.Cartesian2(20, -20),
          scaleByDistance: new Cesium.NearFarScalar(1.5e2, 1.5, 1.5e7, 0.5),
          horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
      },
      description: dataInstance,
    }
  } else {
    return  {
      id: dataInstance.id,
      name : 'track',
      position: position,
      show: isVisible,
      orientation: orientation,
      model: {
          uri: airplane3D,
          minimumPixelSize: 45,
          color: getColor('Yellow', 1.0),
          colorBlendMode: getColorBlendMode('Replace'),
          colorBlendAmount: parseFloat(0.5),
          colorBlendAmountEnabled : true, 
      },
      label: {
          text: dataInstance.placeholder,
          font: "10px sans-serif",
          showBackground: true,
          pixelOffset: new Cesium.Cartesian2(20, -20),
          scaleByDistance: new Cesium.NearFarScalar(1.5e2, 1.5, 1.5e7, 0.5),
          horizontalOrigin: Cesium.HorizontalOrigin.LEFT,
      },
      description: dataInstance,
    }
  }
}

export function createTrackHistoryEntity(stat, dataInstance){

  let isVisible = true 
  if(stat.isEnrouteTrackVisible){
    isVisible = true
  } else{
    isVisible = false
  }
  
  let pos = []
  let lat = []
  let lng = []
  let min = []
  let max = []
  let outline = []
  let posFiltered = []
  let maxFiltered = []
  let outlineFiltered = []
  lng.push(dataInstance.pos.lng)
  pos.push(dataInstance.pos.lng)
  lat.push(dataInstance.pos.lat)
  pos.push(dataInstance.pos.lat)
  min.push(0)
  max.push(dataInstance.pos.height)     
  outline.push(dataInstance.pos.lng)
  outline.push(dataInstance.pos.lat)
  outline.push(0) 
  posFiltered.push(dataInstance.pos.lng)
  posFiltered.push(dataInstance.pos.lat)
  maxFiltered.push(dataInstance.pos.height)     
  outlineFiltered.push(dataInstance.pos.lng)
  outlineFiltered.push(dataInstance.pos.lat)
  outlineFiltered.push(dataInstance.pos.height) 

  let obj ={}
  obj.callSign = dataInstance.callSign
  obj.lastUpdate  = new Date().getTime()
  obj.pos = pos
  obj.min = min
  obj.max = max
  obj.lat = lat
  obj.lng = lng
  stat.trackHistory.push(obj)

  let newColor = Cesium.Color.BLUE
  if(stat.selectedAirport ===''){
    newColor = Cesium.Color.BLUE
  } else if(stat.selectedAirport ==='RKSS'||stat.selectedAirport ==='GMP'){
    if(dataInstance.dep==='GMP'){
      newColor = Cesium.Color.BLUE
    } else if(dataInstance.arr==='GMP'){
      newColor = Cesium.Color.RED
    }else {
      newColor = Cesium.Color.GOLD 
    }
  } else if(stat.selectedAirport ==='RKPK'||stat.selectedAirport ==='PUS'){
    if(dataInstance.dep==='PUS'){
      newColor = Cesium.Color.BLUE
    } else if(dataInstance.arr==='PUS'){
      newColor = Cesium.Color.RED
    }else {
      newColor = Cesium.Color.GOLD 
    }
  } else if(stat.selectedAirport ==='RKPC'||stat.selectedAirport ==='CJU'){
    if(dataInstance.dep==='CJU'){
      newColor = Cesium.Color.BLUE
    } else if(dataInstance.arr==='CJU'){
      newColor = Cesium.Color.RED
    }else {
      newColor = Cesium.Color.GOLD 
    }
  }
  
  if(maxFiltered.length*3!==outlineFiltered.length) return

  stat.cesiumInstance.viewer.entities.add({
      id: uuid(),
      name: "trackHistory",
      historyType : 'wall',
      callSign : dataInstance.callSign,
      show: false,
      wall: {
        positions: Cesium.Cartesian3.fromDegreesArray(pos),
        maximumHeights: max,
        minimumHeights: min,
        material: Cesium.Color.WHITE.withAlpha(0.3),
        outline: true,
        outlineColor : Cesium.Color.BLACK
      },
      description: dataInstance
    }
  )

  stat.cesiumInstance.viewer.entities.add({
    id: uuid(),
    name: "trackHistory",
    historyType : 'wall-filtered',
    callSign : dataInstance.callSign,
    show: isVisible,
    wall: {
      positions: Cesium.Cartesian3.fromDegreesArray(posFiltered),
      maximumHeights: maxFiltered,
      minimumHeights: min,
      material: Cesium.Color.WHITE.withAlpha(0.3),
      outline: true,
      outlineColor : Cesium.Color.BLACK
    },
    description: dataInstance
  })

  stat.cesiumInstance.viewer.entities.add({
    id: uuid(),
    name: "trackHistory",
    historyType : 'polyline1',
    callSign : dataInstance.callSign,
    show: isVisible,
    polyline: {
      positions: Cesium.Cartesian3.fromDegreesArrayHeights(outline),
      width: 2,
      material: new Cesium.PolylineDashMaterialProperty({
        color: newColor,
      }),
    },
    description: dataInstance
  })   

  stat.cesiumInstance.viewer.entities.add({
    id: uuid(),
    name: "trackHistory",
    historyType : 'polyline2',
    callSign : dataInstance.callSign,
    show : false,
    polyline: {
      positions: Cesium.Cartesian3.fromDegreesArrayHeights(outline),
      width: 2,
      material: new Cesium.PolylineDashMaterialProperty({
        color: newColor,
      }),
    },
    description: dataInstance
  })   

  stat.cesiumInstance.viewer.entities.add({
      id: uuid(),
      name: "trackHistory",
      historyType : 'polyline1-filtered',
      callSign : dataInstance.callSign,
      show: isVisible,
      polyline: {
        positions: Cesium.Cartesian3.fromDegreesArrayHeights(outlineFiltered),
        width: 2,
        material: new Cesium.PolylineOutlineMaterialProperty({
          color: newColor,
        }),
      },
      description: dataInstance
    })   

    stat.cesiumInstance.viewer.entities.add({
      id: uuid(),
      name: "trackHistory",
      historyType : 'polyline2-filtered',
      callSign : dataInstance.callSign,
      show : false,
      polyline: {
        positions: Cesium.Cartesian3.fromDegreesArrayHeights(outlineFiltered),
        width: 3,
        material: new Cesium.PolylineOutlineMaterialProperty({
          color: newColor,
        }),
      },
      description: dataInstance
    })   
}

export function addTrackHistoryEntity(stat, dataInstance){
  let isVisible = true 
  if(stat.isEnrouteTrackVisible){
    isVisible = true
  } else{
    isVisible = false
  }
  let entityWall = null
  let entityPolyline1 = null 
  let entityPolyline2 = null 
  let entityWallFiltered = null
  let entityPolyline1Filtered = null 
  let entityPolyline2Filtered = null 
  let pos = []
  let lat = []
  let lng = []
  let min = []
  let max = []
  let outline = []
  let posFiltered = []
  let maxFiltered = []
  let outlineFiltered = []

  for(let j in stat.trackHistory){
    if(stat.trackHistory[j].callSign === dataInstance.callSign){
      pos = stat.trackHistory[j].pos
      min = stat.trackHistory[j].min
      max = stat.trackHistory[j].max
      lat = stat.trackHistory[j].lat
      lng = stat.trackHistory[j].lng
    }
  }

  pos.push(Number(dataInstance.pos.lng))
  pos.push(Number(dataInstance.pos.lat))
  lat.push(Number(dataInstance.pos.lat))
  lng.push(Number(dataInstance.pos.lng))
  min.push(0)
  max.push(Number(dataInstance.pos.height))

  let observation = []

  for(let i in lat){
    observation.push([Number(lat[i]),Number(lng[i]),Number(max[i])])
  }
  let filtered = kFilter.filterAll(observation)

  for(let i in filtered){
    posFiltered.push(filtered[i][1])
    posFiltered.push(filtered[i][0])
    outline.push(filtered[i][1])
    outline.push(filtered[i][0])    
    outline.push(0)  
    outlineFiltered.push(filtered[i][1])
    outlineFiltered.push(filtered[i][0])
    outlineFiltered.push(filtered[i][2])
    maxFiltered.push(filtered[i][2])
  }
  if(maxFiltered.length*3!==outlineFiltered.length) return

  if(min.length >= 20){
    pos.shift()
    pos.shift()
    min.shift()
    max.shift()
    outline.shift()
    outline.shift()
    outline.shift()
    lat.shift()
    lng.shift()
    maxFiltered.shift()
    posFiltered.shift()
    posFiltered.shift()
    outlineFiltered.shift()
    outlineFiltered.shift()
    outlineFiltered.shift()
  }
  let wall = {
    positions: Cesium.Cartesian3.fromDegreesArray(pos),
    maximumHeights: max,
    minimumHeights: min,
    material: Cesium.Color.WHITE.withAlpha(0.3),
    outline: true,
    outlineColor : Cesium.Color.BLACK
  }

  let wallFiltered = {
    positions: Cesium.Cartesian3.fromDegreesArray(posFiltered),
    maximumHeights: maxFiltered,
    minimumHeights: min,
    material: Cesium.Color.WHITE.withAlpha(0.3),
    outline: true,
    outlineColor : Cesium.Color.BLACK
  }

  for(let i in stat.cesiumInstance.viewer.entities.values){
    if(stat.cesiumInstance.viewer.entities.values[i]['_name']==='trackHistory'){
      if(stat.cesiumInstance.viewer.entities.values[i]['_callSign'] === dataInstance.callSign){
        let entity = stat.cesiumInstance.viewer.entities.values[i]
        if(entity.historyType ==='polyline1') {
          entityPolyline1 = entity
        } else if (entity.historyType ==='polyline2') {
          entityPolyline2 = entity
        } else if(entity.historyType ==='wall') {
          entityWall = entity
        } else if (entity.historyType ==='polyline2-filtered') {
          entityPolyline2Filtered = entity
        } else if(entity.historyType ==='wall-filtered') {
          entityWallFiltered = entity
        } else if (entity.historyType ==='polyline1-filtered') {
          entityPolyline1Filtered = entity
        } 
      }
    }
  }

  if(isVisible){
    if(entityWall) entityWall.wall = wall 
    if(entityWallFiltered) entityWallFiltered.wall = wallFiltered 

    if(entityPolyline1) entityPolyline1.polyline.positions = Cesium.Cartesian3.fromDegreesArrayHeights(outline)
    if(entityPolyline2) entityPolyline2.polyline.positions = Cesium.Cartesian3.fromDegreesArrayHeights(outline)

    if(entityPolyline1Filtered) entityPolyline1Filtered.polyline.positions = Cesium.Cartesian3.fromDegreesArrayHeights(outlineFiltered)
    if(entityPolyline2Filtered) entityPolyline2Filtered.polyline.positions = Cesium.Cartesian3.fromDegreesArrayHeights(outlineFiltered)

    if(entityPolyline1.show === true){
      setTimeout(()=>{
        if(entityPolyline2){
          entityPolyline2Filtered.show = true
          entityPolyline2.show = true
        }
        if(entityPolyline1){
          entityPolyline1Filtered.show = false
          entityPolyline1.show = false
        }
      },100)
    } else {
      setTimeout(()=>{
        if(entityPolyline1){
          entityPolyline1Filtered.show = true
          entityPolyline1.show = true
        }
        if(entityPolyline2){
          entityPolyline2Filtered.show = false  
          entityPolyline2.show = false
        }
      },100)
    }
  }

  for(let j in stat.trackHistory){
    if(stat.trackHistory[j].callSign=== dataInstance.callSign){
      stat.trackHistory[j].pos = pos
      stat.trackHistory[j].min = min
      stat.trackHistory[j].max = max
      stat.trackHistory[j].lat = lat
      stat.trackHistory[j].lng = lng
      stat.trackHistory[j].lastUpdate  = new Date().getTime()
    }
  }
}

export function getDistance(lat1, lon1, lat2, lon2, unit) {
  var radlat1 = Math.PI * lat1/180
  var radlat2 = Math.PI * lat2/180
  var theta = lon1-lon2
  var radtheta = Math.PI * theta/180
  var dist = Math.sin(radlat1) * Math.sin(radlat2) + Math.cos(radlat1) * Math.cos(radlat2) * Math.cos(radtheta)
  dist = Math.acos(dist)
  dist = dist * 180/Math.PI
  dist = dist * 60 * 1.1515
  if (unit=="M") { dist = dist * 1.609344 * 1000 }
  if (unit=="N") { dist = dist * 0.8684 }
  return dist
}

export function addTrackDistanceEntity (stat, dataInstance){

  let horizontalDistance = getDistance(stat.address.x, stat.address.y, dataInstance.pos.lng, dataInstance.pos.lat ,"M")
  
  let distance = Math.sqrt(Math.pow(Number(horizontalDistance), 2) + Math.pow(Number(dataInstance.pos.height) - 0,2))

  let entity1 = null 
  let entity2 = null 

  for(let i in stat.cesiumInstance.viewer.entities.values){
    if(stat.cesiumInstance.viewer.entities.values[i]['_name']==='addressDistancePolyline')
      {
        if(stat.cesiumInstance.viewer.entities.values[i]['_callSign'] === dataInstance.callSign){
          entity1 = stat.cesiumInstance.viewer.entities.values[i]
        }
      }  
      if(stat.cesiumInstance.viewer.entities.values[i]['_name']==='addressDistanceLabel')
      {
        if(stat.cesiumInstance.viewer.entities.values[i]['_callSign'] === dataInstance.callSign){
          entity2 = stat.cesiumInstance.viewer.entities.values[i]
        }
      }  
  }

  stat.cesiumInstance.viewer.entities.remove(entity1)
  stat.cesiumInstance.viewer.entities.remove(entity2)

  if(distance < stat.domSize-200){

    stat.cesiumInstance.viewer.entities.add({
      id: uuid(),
      callSign : dataInstance.callSign, 
      name: "addressDistancePolyline",
      show : true,
      polyline : {
          positions : Cesium.Cartesian3.fromDegreesArrayHeights([stat.address.x, stat.address.y, 0, dataInstance.pos.lng, dataInstance.pos.lat, dataInstance.pos.height]),
          width : 2,
          material : new Cesium.PolylineOutlineMaterialProperty({
              color: Cesium.Color.GREENYELLOW 
          })
      },
      }) 

      let label = {
        font : '14px monospace',
        showBackground : true,
        text : parseInt(distance).toString()+'m', 
        horizontalOrigin : Cesium.HorizontalOrigin.CENTER,
        verticalOrigin : Cesium.VerticalOrigin.CENTER,
        pixelOffset : new Cesium.Cartesian2(0, 0),
        eyeOffset: new Cesium.Cartesian3(0,0,-50),
      }
      
      stat.cesiumInstance.viewer.entities.add({
        name: 'addressDistanceLabel',
        id : uuid(),
        callSign : dataInstance.callSign, 
        position: Cesium.Cartesian3.fromDegrees((Number(stat.address.x)+Number(dataInstance.pos.lng))/2,(Number(stat.address.y)+Number(dataInstance.pos.lat))/2,(Number(dataInstance.pos.height))/2),
        label: label
      })

  } 
}

export function changeAircraftColor (stat, selectedAirport) {
  if(selectedAirport ===''){
    for(let i in stat.cesiumInstance.viewer.entities.values){
      if(stat.cesiumInstance.viewer.entities.values[i]['_name']==='trackHistory'){
          let entity = stat.cesiumInstance.viewer.entities.values[i]
          if(entity.historyType ==='polyline1') 
          {
            entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
              color:  Cesium.Color.BLUE,
            })
          } else if (entity.historyType ==='polyline2') {
            entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
              color:  Cesium.Color.BLUE,
            })
          } if(entity.historyType ==='polyline1-filtered') 
          {
            entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
              color:  Cesium.Color.BLUE,
            })
          } else if (entity.historyType ==='polyline2-filtered') {
            entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
              color:  Cesium.Color.BLUE,
            })
          } 
      }
    }
  } else if(selectedAirport ==='RKSS'||selectedAirport ==='GMP'){
    for(let i in stat.cesiumInstance.viewer.entities.values){
      if(stat.cesiumInstance.viewer.entities.values[i]['_name']==='trackHistory'){
          let entity = stat.cesiumInstance.viewer.entities.values[i]
          if(entity.historyType ==='polyline1') 
          {
            if(entity.description['_value'].dep==='GMP'||entity.description['_value'].dep==='RKSS'){
              entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                color:  Cesium.Color.BLUE,
              })
            } else if(entity.description['_value'].arr==='GMP'||entity.description['_value'].arr==='RKSS'){
              entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                color:  Cesium.Color.RED,
              })
            }else {
              entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                color:  Cesium.Color.GOLD,
              })
            }
          } else if (entity.historyType ==='polyline2') {
            if(entity.description['_value'].dep==='GMP'||entity.description['_value'].dep==='RKSS'){
              entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                color:  Cesium.Color.BLUE,
              })
            } else if(entity.description['_value'].arr==='GMP'||entity.description['_value'].arr==='RKSS'){
              entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                color:  Cesium.Color.RED,
              })
            }else {
              entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                color:  Cesium.Color.GOLD,
              })
            }
          } else if(entity.historyType ==='polyline1-filtered') 
          {
            if(entity.description['_value'].dep==='GMP'||entity.description['_value'].dep==='RKSS'){
              entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                color:  Cesium.Color.BLUE,
              })
            } else if(entity.description['_value'].arr==='GMP'||entity.description['_value'].arr==='RKSS'){
              entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                color:  Cesium.Color.RED,
              })
            }else {
              entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                color:  Cesium.Color.GOLD,
              })
            }
          } else if (entity.historyType ==='polyline2-filtered') {
            if(entity.description['_value'].dep==='GMP'||entity.description['_value'].dep==='RKSS'){
              entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                color:  Cesium.Color.BLUE,
              })
            } else if(entity.description['_value'].arr==='GMP'||entity.description['_value'].arr==='RKSS'){
              entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                color:  Cesium.Color.RED,
              })
            }else {
              entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                color:  Cesium.Color.GOLD,
              })
            }
          } 
      }
    }
  } else if(selectedAirport ==='RKPK'||selectedAirport ==='PUS'){
    for(let i in stat.cesiumInstance.viewer.entities.values){
      if(stat.cesiumInstance.viewer.entities.values[i]['_name']==='trackHistory'){
          let entity = stat.cesiumInstance.viewer.entities.values[i]
          if(entity.historyType ==='polyline1') 
          {
            if(entity.description['_value'].dep==='PUS'||entity.description['_value'].dep==='RKPK'){
              entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                color:  Cesium.Color.BLUE,
              })
            } else if(entity.description['_value'].arr==='PUS'||entity.description['_value'].arr==='RKPK'){
              entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                color:  Cesium.Color.RED,
              })
            }else {
              entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                color:  Cesium.Color.GOLD,
              })
            }
          } else if (entity.historyType ==='polyline2') {
            if(entity.description['_value'].dep==='PUS'||entity.description['_value'].dep==='RKPK'){
              entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                color:  Cesium.Color.BLUE,
              })
            } else if(entity.description['_value'].arr==='PUS'||entity.description['_value'].arr==='RKPK'){
              entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                color:  Cesium.Color.RED,
              })
            }else {
              entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                color:  Cesium.Color.GOLD,
              })
            }
          } else if(entity.historyType ==='polyline1-filtered') 
          {
            if(entity.description['_value'].dep==='PUS'||entity.description['_value'].dep==='RKPK'){
              entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                color:  Cesium.Color.BLUE,
              })
            } else if(entity.description['_value'].arr==='PUS'||entity.description['_value'].arr==='RKPK'){
              entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                color:  Cesium.Color.RED,
              })
            }else {
              entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                color:  Cesium.Color.GOLD,
              })
            }
          } else if (entity.historyType ==='polyline2-filtered') {
            if(entity.description['_value'].dep==='PUS'||entity.description['_value'].dep==='RKPK'){
              entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                color:  Cesium.Color.BLUE,
              })
            } else if(entity.description['_value'].arr==='PUS'||entity.description['_value'].arr==='RKPK'){
              entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                color:  Cesium.Color.RED,
              })
            }else {
              entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                color:  Cesium.Color.GOLD,
              })
            }
          }
      }
    }
  } else if(selectedAirport ==='RKPC'||selectedAirport ==='CJU'){
    for(let i in stat.cesiumInstance.viewer.entities.values){
      if(stat.cesiumInstance.viewer.entities.values[i]['_name']==='trackHistory'){
          let entity = stat.cesiumInstance.viewer.entities.values[i]
          if(entity.historyType ==='polyline1') 
          {
            if(entity.description['_value'].dep==='CJU'||entity.description['_value'].dep==='RKPC'){
              entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                color:  Cesium.Color.BLUE,
              })
            } else if(entity.description['_value'].arr==='CJU'||entity.description['_value'].arr==='RKPC'){
              entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                color:  Cesium.Color.RED,
              })
            }else {
              entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                color:  Cesium.Color.GOLD,
              })
            }
          } else if (entity.historyType ==='polyline2') {
            if(entity.description['_value'].dep==='CJU'||entity.description['_value'].dep==='RKPC'){
              entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                color:  Cesium.Color.BLUE,
              })
            } else if(entity.description['_value'].arr==='CJU'||entity.description['_value'].arr==='RKPC'){
              entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                color:  Cesium.Color.RED,
              })
            }else {
              entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                color:  Cesium.Color.GOLD,
              })
            }
          } else if(entity.historyType ==='polyline1-filtered') 
          {
            if(entity.description['_value'].dep==='CJU'||entity.description['_value'].dep==='RKPC'){
              entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                color:  Cesium.Color.BLUE,
              })
            } else if(entity.description['_value'].arr==='CJU'||entity.description['_value'].arr==='RKPC'){
              entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                color:  Cesium.Color.RED,
              })
            }else {
              entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                color:  Cesium.Color.GOLD,
              })
            }
          } else if (entity.historyType ==='polyline2-filtered') {
            if(entity.description['_value'].dep==='CJU'||entity.description['_value'].dep==='RKPC'){
              entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                color:  Cesium.Color.BLUE,
              })
            } else if(entity.description['_value'].arr==='CJU'||entity.description['_value'].arr==='RKPC'){
              entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                color:  Cesium.Color.RED,
              })
            }else {
              entity.polyline.material = new Cesium.PolylineOutlineMaterialProperty({
                color:  Cesium.Color.GOLD,
              })
            }
          } 
      }
    }
  }
}

export function getColorBlendMode (colorBlendMode) {
    return Cesium.ColorBlendMode[colorBlendMode.toUpperCase()]
}

export function getColor (colorName, alpha) {
    var color = Cesium.Color[colorName.toUpperCase()]
    return Cesium.Color.fromAlpha(color, parseFloat(alpha))
}

export function getPosition (data){
    return Cesium.Cartesian3.fromDegrees(Number.parseFloat(data.pos.lng), Number.parseFloat(data.pos.lat), Number.parseFloat(data.pos.height))
}


export function getHpr(a,b,c){
    return new Cesium.HeadingPitchRoll(Cesium.Math.toRadians(a), b, c)
}

export function getOrientation(position,hpr){
  return Cesium.Transforms.headingPitchRollQuaternion(position,hpr) 
}

export function startWatchDog(stat){
  let currentTimeStamp = new Date().getTime()
  for(let m in stat.trackHistory){
    let calculatedTimeStamp = currentTimeStamp -stat.trackHistory[m].lastUpdate
    if(calculatedTimeStamp>30000){
      let callSignToDelete = stat.trackHistory[m].callSign
      let entityWall = null
      let entityPolyline1 = null 
      let entityPolyline2 = null 
      let entityWallFiltered = null
      let entityPolyline1Filtered = null 
      let entityPolyline2Filtered = null 
      let entityDistance = null 
      let entityDistanceLabel = null

      for(let i in stat.cesiumInstance.viewer.entities.values){
        if(stat.cesiumInstance.viewer.entities.values[i]['_name']==='trackHistory'){
          if(stat.cesiumInstance.viewer.entities.values[i]['_callSign'] === callSignToDelete){
            let entity = stat.cesiumInstance.viewer.entities.values[i]
            if(entity.historyType ==='polyline1') {
              entityPolyline1 = entity
            } else if (entity.historyType ==='polyline2') {
              entityPolyline2 = entity
            } else if(entity.historyType ==='wall') {
              entityWall = entity
            } else if(entity.historyType ==='polyline1-filtered') {
              entityPolyline1Filtered = entity
            } else if (entity.historyType ==='polyline2-filtered') {
              entityPolyline2Filtered = entity
            } else if(entity.historyType ==='wall-filtered') {
              entityWallFiltered = entity
            }
          }
        }

        if(stat.cesiumInstance.viewer.entities.values[i]['_name']==='addressDistancePolyline'){
          if(stat.cesiumInstance.viewer.entities.values[i]['_callSign'] === callSignToDelete){
            entityDistance = stat.cesiumInstance.viewer.entities.values[i]
          }
        }
        
        if(stat.cesiumInstance.viewer.entities.values[i]['_name']==='addressDistanceLabel'){
          if(stat.cesiumInstance.viewer.entities.values[i]['_callSign'] === callSignToDelete){
            entityDistanceLabel = stat.cesiumInstance.viewer.entities.values[i]
          }
        }
      }
      if(entityDistance) stat.cesiumInstance.viewer.entities.remove(entityDistance)
      if(entityDistanceLabel) stat.cesiumInstance.viewer.entities.remove(entityDistanceLabel)
      stat.cesiumInstance.viewer.entities.remove(entityWall)
      stat.cesiumInstance.viewer.entities.remove(entityPolyline2)
      stat.cesiumInstance.viewer.entities.remove(entityPolyline1)
      stat.cesiumInstance.viewer.entities.remove(entityWallFiltered)
      stat.cesiumInstance.viewer.entities.remove(entityPolyline2Filtered)
      stat.cesiumInstance.viewer.entities.remove(entityPolyline1Filtered)

      for(let j in stat.trackHistory){
        if(stat.trackHistory[j].callSign === callSignToDelete){
          stat.trackHistory.splice(j, 1)
        }
      }
    }
  }

  for(let i in stat.cesiumInstance.viewer.entities.values){
    if(stat.cesiumInstance.viewer.entities.values[i]['_name']==='track'){
      let calculatedTimeStamp = currentTimeStamp - stat.cesiumInstance.viewer.entities.values[i].description['_value'].lastUpdate
      if(calculatedTimeStamp>30000){
        let callSignToDelete = stat.cesiumInstance.viewer.entities.values[i].description['_value'].callSign
        stat.cesiumInstance.viewer.entities.removeById(stat.cesiumInstance.viewer.entities.values[i].id)
        for(let c = 0; c < stat.trackData.length; c++){
          if (stat.trackData[c].callSign === callSignToDelete) {
              stat.trackData.splice(c, 1)
          }
        }
      }
    }
  }
}

export function toggleEnrouteTrackHistory(stat, flag) {
  if(stat.selectedTrackHistoryEntity){
    if(flag){
      if(!stat.isNotEnrouteTrackHistoryLineVisible){
        stat.selectedTrackHistoryOutlineEntity.show = true
      }
      stat.selectedTrackHistoryEntity.show = true
    } else {
      stat.selectedTrackHistoryOutlineEntity.show = false
      stat.selectedTrackHistoryOutlineEntity2.show = false
      stat.selectedTrackHistoryEntity.show = false
    }
  }
}




